import { useMemo } from "react";
import styles from "./NBLogo.module.css";

const NBLogo = ({onClick= ()=>{}}) => {
  return (
    <img src="logo.png" alt="NB Logo" className={styles.logo} onClick={onClick} />
  );
};

export default NBLogo;
